<div class="flex-container">
  <div class="flex-row">
    <div class="flex-col-6 flex-col-sm-12 categories">
      <app-profile-category
        *ngIf="stepStatus > 0 || hasCIAccount"
        [title]="'profile.title'"
        [activeTab]="activeTabName === 'showPersonal'"
        (click)="updateOpenedTab('showPersonal')"
      ></app-profile-category>
      <app-profile-category
        *ngIf="hasI4KAccount"
        [title]="'profile.I4K.title'"
        [activeTab]="activeTabName === 'showI4K'"
        (click)="updateOpenedTab('showI4K')"
      ></app-profile-category>
      <app-profile-category
        [title]="'personal.change_pass'"
        [activeTab]="activeTabName === 'showPass'"
        (click)="updateOpenedTab('showPass')"
      ></app-profile-category>
      <app-profile-category
        *ngIf="customer.provider === 'email' && customer.app_location === 'ch' && (stepStatus > 0 || hasCIAccount)"
        [title]="'profile.2fa'"
        [activeTab]="activeTabName === 'show2FA'"
        (click)="updateOpenedTab('show2FA')"
      ></app-profile-category>
      <app-profile-category
        [title]="'profile.language.title'"
        [activeTab]="activeTabName === 'showLanguage'"
        (click)="updateOpenedTab('showLanguage')"
      ></app-profile-category>
      <a class="promotions-link" (click)="updateShowPromotions()">
        {{ (stepStatus === 5 ? 'modals.promotions.h2' : 'modals.promotions-referrals.h2-both') | translate }}
      </a>
    </div>

    <div class="flex-col-6 flex-col-sm-12 tab-details">
      <app-profile-personal-details
        *ngIf="activeTabName === 'showPersonal'"
        (changeTab)="updateOpenedTab($event)"
      ></app-profile-personal-details>
      <app-profile-i4k-names *ngIf="activeTabName === 'showI4K'" [customer]="customer"></app-profile-i4k-names>
      <app-profile-change-password *ngIf="activeTabName === 'showPass'" [customer]="customer"></app-profile-change-password>
      <app-profile-change-language *ngIf="activeTabName === 'showLanguage'" [customer]="customer"></app-profile-change-language>
      <app-profile-2fa *ngIf="activeTabName === 'show2FA'"></app-profile-2fa>
    </div>
  </div>
</div>
